import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import english from '@/language/english'
import chinese from '@/language/chinese'
import VueCookie from "vuecookie";
import Vue from 'vue'
import VueI18n from 'vue-i18n'
Vue.use(VueCookie);
Vue.use(VueI18n)

Vue.config.productionTip = false;

// Create VueI18n instance with options
export const i18n = new VueI18n({
    locale: VueCookie.get('lang') || 'zh-CN',
    messages: {
        'zh-CN': {
            ...zhLocale,
            ...chinese
        },
        'en': {
            ...enLocale,
            ...english
        },
    }
});
